import { CountryPhoneCode } from '../../../_models/models';

export const COUNTRY_PHONE_CODES: CountryPhoneCode[] = [
  { countryCode: '+1', iso: 'US', validLengths: [10] },
  { countryCode: '+247', iso: 'AC', validLengths: [4] },
  { countryCode: '+376', iso: 'AD', validLengths: [6, 9] },
  { countryCode: '+971', iso: 'AE', validLengths: [9] },
  { countryCode: '+93', iso: 'AF', validLengths: [9] },
  { countryCode: '+1', iso: 'AG', validLengths: [10] },
  { countryCode: '+1', iso: 'AI', validLengths: [10] },
  { countryCode: '+355', iso: 'AL', validLengths: [9] },
  { countryCode: '+374', iso: 'AM', validLengths: [8] },
  { countryCode: '+244', iso: 'AO', validLengths: [9] },
  { countryCode: '+672', iso: 'AQ', validLengths: [5] },
  { countryCode: '+54', iso: 'AR', validLengths: [10] },
  { countryCode: '+1', iso: 'AS', validLengths: [10] },
  { countryCode: '+43', iso: 'AT', validLengths: [10, 11] },
  { countryCode: '+61', iso: 'AU', validLengths: [9] },
  { countryCode: '+297', iso: 'AW', validLengths: [7] },
  { countryCode: '+358', iso: 'AX', validLengths: [9, 10] },
  { countryCode: '+994', iso: 'AZ', validLengths: [9] },
  { countryCode: '+387', iso: 'BA', validLengths: [8] },
  { countryCode: '+1', iso: 'BB', validLengths: [10] },
  { countryCode: '+880', iso: 'BD', validLengths: [10] },
  { countryCode: '+32', iso: 'BE', validLengths: [9] },
  { countryCode: '+226', iso: 'BF', validLengths: [8] },
  { countryCode: '+359', iso: 'BG', validLengths: [9] },
  { countryCode: '+973', iso: 'BH', validLengths: [8] },
  { countryCode: '+257', iso: 'BI', validLengths: [8] },
  { countryCode: '+229', iso: 'BJ', validLengths: [8] },
  { countryCode: '+590', iso: 'BL', validLengths: [9] },
  { countryCode: '+1', iso: 'BM', validLengths: [10] },
  { countryCode: '+673', iso: 'BN', validLengths: [7] },
  { countryCode: '+591', iso: 'BO', validLengths: [8] },
  { countryCode: '+599', iso: 'BQ', validLengths: [7] },
  { countryCode: '+55', iso: 'BR', validLengths: [10, 11] },
  { countryCode: '+1', iso: 'BS', validLengths: [10] },
  { countryCode: '+975', iso: 'BT', validLengths: [8] },
  { countryCode: '+47', iso: 'BV', validLengths: [8] },
  { countryCode: '+375', iso: 'BY', validLengths: [9] },
  { countryCode: '+501', iso: 'BZ', validLengths: [7] },
  { countryCode: '+1', iso: 'CA', validLengths: [10] },
  { countryCode: '+61', iso: 'CC', validLengths: [9] },
  { countryCode: '+243', iso: 'CD', validLengths: [9] },
  { countryCode: '+236', iso: 'CF', validLengths: [8] },
  { countryCode: '+242', iso: 'CG', validLengths: [9] },
  { countryCode: '+41', iso: 'CH', validLengths: [9] },
  { countryCode: '+225', iso: 'CI', validLengths: [8] },
  { countryCode: '+682', iso: 'CK', validLengths: [5] },
  { countryCode: '+86', iso: 'CN', validLengths: [11] },
  { countryCode: '+57', iso: 'CO', validLengths: [10] },
  { countryCode: '+506', iso: 'CR', validLengths: [8] },
  { countryCode: '+53', iso: 'CU', validLengths: [8] },
  { countryCode: '+238', iso: 'CV', validLengths: [7] },
  { countryCode: '+599', iso: 'CW', validLengths: [7] },
  { countryCode: '+61', iso: 'CX', validLengths: [9] },
  { countryCode: '+420', iso: 'CZ', validLengths: [9] },
  { countryCode: '+49', iso: 'DE', validLengths: [10, 11] },
  { countryCode: '+253', iso: 'DJ', validLengths: [8] },
  { countryCode: '+45', iso: 'DK', validLengths: [8] },
  { countryCode: '+1', iso: 'DM', validLengths: [10] },
  { countryCode: '+1', iso: 'DO', validLengths: [10] },
  { countryCode: '+213', iso: 'DZ', validLengths: [9] },
  { countryCode: '+593', iso: 'EC', validLengths: [9] },
  { countryCode: '+372', iso: 'EE', validLengths: [7, 8] },
  { countryCode: '+20', iso: 'EG', validLengths: [10] },
  { countryCode: '+212', iso: 'EH', validLengths: [9] },
  { countryCode: '+291', iso: 'ER', validLengths: [7] },
  { countryCode: '+34', iso: 'ES', validLengths: [9] },
  { countryCode: '+251', iso: 'ET', validLengths: [9] },
  { countryCode: '+358', iso: 'FI', validLengths: [9, 10] },
  { countryCode: '+679', iso: 'FJ', validLengths: [7] },
  { countryCode: '+500', iso: 'FK', validLengths: [5] },
  { countryCode: '+691', iso: 'FM', validLengths: [7] },
  { countryCode: '+298', iso: 'FO', validLengths: [6] },
  { countryCode: '+33', iso: 'FR', validLengths: [9] },
  { countryCode: '+241', iso: 'GA', validLengths: [7] },
  { countryCode: '+44', iso: 'GB', validLengths: [10] },
  { countryCode: '+1', iso: 'GD', validLengths: [10] },
  { countryCode: '+995', iso: 'GE', validLengths: [9] },
  { countryCode: '+594', iso: 'GF', validLengths: [9] },
  { countryCode: '+44', iso: 'GG', validLengths: [10] },
  { countryCode: '+233', iso: 'GH', validLengths: [9] },
  { countryCode: '+299', iso: 'GL', validLengths: [6] },
  { countryCode: '+220', iso: 'GM', validLengths: [7] },
  { countryCode: '+224', iso: 'GN', validLengths: [9] },
  { countryCode: '+590', iso: 'GP', validLengths: [9] },
  { countryCode: '+240', iso: 'GQ', validLengths: [9] },
  { countryCode: '+30', iso: 'GR', validLengths: [10] },
  { countryCode: '+502', iso: 'GT', validLengths: [8] },
  { countryCode: '+1', iso: 'GU', validLengths: [10] },
  { countryCode: '+245', iso: 'GW', validLengths: [9] },
  { countryCode: '+592', iso: 'GY', validLengths: [7] },
  { countryCode: '+852', iso: 'HK', validLengths: [8] },
  { countryCode: '+852', iso: 'HK', validLengths: [8] },
  { countryCode: '+504', iso: 'HN', validLengths: [8] },
  { countryCode: '+385', iso: 'HR', validLengths: [9] },
  { countryCode: '+509', iso: 'HT', validLengths: [8] },
  { countryCode: '+36', iso: 'HU', validLengths: [9] },
  { countryCode: '+62', iso: 'ID', validLengths: [10, 11] },
  { countryCode: '+353', iso: 'IE', validLengths: [9] },
  { countryCode: '+972', iso: 'IL', validLengths: [9, 10] },
  { countryCode: '+44', iso: 'IM', validLengths: [10] },
  { countryCode: '+91', iso: 'IN', validLengths: [10] },
  { countryCode: '+246', iso: 'IO', validLengths: [7] },
  { countryCode: '+964', iso: 'IQ', validLengths: [10] },
  { countryCode: '+98', iso: 'IR', validLengths: [10] },
  { countryCode: '+354', iso: 'IS', validLengths: [7, 8] },
  { countryCode: '+39', iso: 'IT', validLengths: [10] },
  { countryCode: '+44', iso: 'JE', validLengths: [10] },
  { countryCode: '+1', iso: 'JM', validLengths: [10] },
  { countryCode: '+962', iso: 'JO', validLengths: [9] },
  { countryCode: '+81', iso: 'JP', validLengths: [10] },
  { countryCode: '+254', iso: 'KE', validLengths: [9] },
  { countryCode: '+996', iso: 'KG', validLengths: [9] },
  { countryCode: '+855', iso: 'KH', validLengths: [9] },
  { countryCode: '+686', iso: 'KI', validLengths: [8] },
  { countryCode: '+269', iso: 'KM', validLengths: [7] },
  { countryCode: '+1', iso: 'KN', validLengths: [10] },
  { countryCode: '+850', iso: 'KP', validLengths: [8, 9] },
  { countryCode: '+82', iso: 'KR', validLengths: [9, 10] },
  { countryCode: '+965', iso: 'KW', validLengths: [8] },
  { countryCode: '+1', iso: 'KY', validLengths: [10] },
  { countryCode: '+7', iso: 'KZ', validLengths: [10] },
  { countryCode: '+856', iso: 'LA', validLengths: [10] },
  { countryCode: '+961', iso: 'LB', validLengths: [8] },
  { countryCode: '+1', iso: 'LC', validLengths: [10] },
  { countryCode: '+423', iso: 'LI', validLengths: [9] },
  { countryCode: '+94', iso: 'LK', validLengths: [9] },
  { countryCode: '+231', iso: 'LR', validLengths: [8] },
  { countryCode: '+266', iso: 'LS', validLengths: [8] },
  { countryCode: '+370', iso: 'LT', validLengths: [8] },
  { countryCode: '+352', iso: 'LU', validLengths: [8, 9] },
  { countryCode: '+371', iso: 'LV', validLengths: [8] },
  { countryCode: '+218', iso: 'LY', validLengths: [9] },
  { countryCode: '+212', iso: 'MA', validLengths: [9] },
  { countryCode: '+377', iso: 'MC', validLengths: [8, 9] },
  { countryCode: '+373', iso: 'MD', validLengths: [8] },
  { countryCode: '+382', iso: 'ME', validLengths: [8] },
  { countryCode: '+590', iso: 'MF', validLengths: [9] },
  { countryCode: '+261', iso: 'MG', validLengths: [9] },
  { countryCode: '+692', iso: 'MH', validLengths: [7] },
  { countryCode: '+389', iso: 'MK', validLengths: [8] },
  { countryCode: '+223', iso: 'ML', validLengths: [8] },
  { countryCode: '+95', iso: 'MM', validLengths: [9] },
  { countryCode: '+976', iso: 'MN', validLengths: [8] },
  { countryCode: '+853', iso: 'MO', validLengths: [8] },
  { countryCode: '+853', iso: 'MO', validLengths: [8] },
  { countryCode: '+1', iso: 'MP', validLengths: [10] },
  { countryCode: '+596', iso: 'MQ', validLengths: [9] },
  { countryCode: '+222', iso: 'MR', validLengths: [8] },
  { countryCode: '+1', iso: 'MS', validLengths: [10] },
  { countryCode: '+356', iso: 'MT', validLengths: [8] },
  { countryCode: '+230', iso: 'MU', validLengths: [7] },
  { countryCode: '+960', iso: 'MV', validLengths: [7] },
  { countryCode: '+265', iso: 'MW', validLengths: [9] },
  { countryCode: '+52', iso: 'MX', validLengths: [10] },
  { countryCode: '+60', iso: 'MY', validLengths: [9, 10] },
  { countryCode: '+258', iso: 'MZ', validLengths: [9] },
  { countryCode: '+264', iso: 'NA', validLengths: [9] },
  { countryCode: '+687', iso: 'NC', validLengths: [6] },
  { countryCode: '+227', iso: 'NE', validLengths: [8] },
  { countryCode: '+234', iso: 'NG', validLengths: [10] },
  { countryCode: '+505', iso: 'NI', validLengths: [8] },
  { countryCode: '+31', iso: 'NL', validLengths: [9] },
  { countryCode: '+47', iso: 'NO', validLengths: [8] },
  { countryCode: '+977', iso: 'NP', validLengths: [10] },
  { countryCode: '+674', iso: 'NR', validLengths: [7] },
  { countryCode: '+683', iso: 'NU', validLengths: [4] },
  { countryCode: '+64', iso: 'NZ', validLengths: [9] },
  { countryCode: '+968', iso: 'OM', validLengths: [8] },
  { countryCode: '+507', iso: 'PA', validLengths: [8] },
  { countryCode: '+51', iso: 'PE', validLengths: [9] },
  { countryCode: '+689', iso: 'PF', validLengths: [6] },
  { countryCode: '+675', iso: 'PG', validLengths: [8] },
  { countryCode: '+63', iso: 'PH', validLengths: [10] },
  { countryCode: '+92', iso: 'PK', validLengths: [10] },
  { countryCode: '+48', iso: 'PL', validLengths: [9] },
  { countryCode: '+508', iso: 'PM', validLengths: [6] },
  { countryCode: '+64', iso: 'PN', validLengths: [6] },
  { countryCode: '+970', iso: 'PS', validLengths: [9] },
  { countryCode: '+351', iso: 'PT', validLengths: [9] },
  { countryCode: '+680', iso: 'PW', validLengths: [7] },
  { countryCode: '+595', iso: 'PY', validLengths: [9] },
  { countryCode: '+974', iso: 'QA', validLengths: [8] },
  { countryCode: '+262', iso: 'RE', validLengths: [9] },
  { countryCode: '+40', iso: 'RO', validLengths: [9] },
  { countryCode: '+381', iso: 'RS', validLengths: [8, 9] },
  { countryCode: '+7', iso: 'RU', validLengths: [10] },
  { countryCode: '+250', iso: 'RW', validLengths: [9] },
  { countryCode: '+966', iso: 'SA', validLengths: [9] },
  { countryCode: '+677', iso: 'SB', validLengths: [7] },
  { countryCode: '+248', iso: 'SC', validLengths: [7] },
  { countryCode: '+249', iso: 'SD', validLengths: [9] },
  { countryCode: '+46', iso: 'SE', validLengths: [9] },
  { countryCode: '+65', iso: 'SG', validLengths: [8] },
  { countryCode: '+290', iso: 'SH', validLengths: [4, 5] },
  { countryCode: '+386', iso: 'SI', validLengths: [8] },
  { countryCode: '+47', iso: 'SJ', validLengths: [8] },
  { countryCode: '+421', iso: 'SK', validLengths: [9] },
  { countryCode: '+232', iso: 'SL', validLengths: [8] },
  { countryCode: '+378', iso: 'SM', validLengths: [10] },
  { countryCode: '+221', iso: 'SN', validLengths: [9] },
  { countryCode: '+252', iso: 'SO', validLengths: [8, 9] },
  { countryCode: '+597', iso: 'SR', validLengths: [7] },
  { countryCode: '+211', iso: 'SS', validLengths: [9] },
  { countryCode: '+239', iso: 'ST', validLengths: [7] },
  { countryCode: '+503', iso: 'SV', validLengths: [8] },
  { countryCode: '+1', iso: 'SX', validLengths: [10] },
  { countryCode: '+963', iso: 'SY', validLengths: [9] },
  { countryCode: '+268', iso: 'SZ', validLengths: [8] },
  { countryCode: '+1', iso: 'TC', validLengths: [10] },
  { countryCode: '+235', iso: 'TD', validLengths: [8] },
  { countryCode: '+262', iso: 'TF', validLengths: [9] },
  { countryCode: '+228', iso: 'TG', validLengths: [8] },
  { countryCode: '+66', iso: 'TH', validLengths: [9] },
  { countryCode: '+992', iso: 'TJ', validLengths: [9] },
  { countryCode: '+690', iso: 'TK', validLengths: [5] },
  { countryCode: '+690', iso: 'TK', validLengths: [5] },
  { countryCode: '+670', iso: 'TL', validLengths: [7] },
  { countryCode: '+993', iso: 'TM', validLengths: [8] },
  { countryCode: '+216', iso: 'TN', validLengths: [8] },
  { countryCode: '+676', iso: 'TO', validLengths: [5] },
  { countryCode: '+90', iso: 'TR', validLengths: [10] },
  { countryCode: '+1', iso: 'TT', validLengths: [10] },
  { countryCode: '+688', iso: 'TV', validLengths: [5] },
  { countryCode: '+886', iso: 'TW', validLengths: [9] },
  { countryCode: '+255', iso: 'TZ', validLengths: [9] },
  { countryCode: '+380', iso: 'UA', validLengths: [9] },
  { countryCode: '+256', iso: 'UG', validLengths: [9] },
  { countryCode: '+598', iso: 'UY', validLengths: [8, 9] },
  { countryCode: '+998', iso: 'UZ', validLengths: [9] },
  { countryCode: '+379', iso: 'VA', validLengths: [9] },
  { countryCode: '+1', iso: 'VC', validLengths: [10] },
  { countryCode: '+58', iso: 'VE', validLengths: [10] },
  { countryCode: '+1', iso: 'VG', validLengths: [10] },
  { countryCode: '+1', iso: 'VI', validLengths: [10] },
  { countryCode: '+84', iso: 'VN', validLengths: [9, 10] },
  { countryCode: '+678', iso: 'VU', validLengths: [7] },
  { countryCode: '+681', iso: 'WF', validLengths: [6] },
  { countryCode: '+685', iso: 'WS', validLengths: [7] },
  { countryCode: '+383', iso: 'XK', validLengths: [8] },
  { countryCode: '+967', iso: 'YE', validLengths: [9] },
  { countryCode: '+262', iso: 'YT', validLengths: [9] },
  { countryCode: '+27', iso: 'ZA', validLengths: [9] },
  { countryCode: '+260', iso: 'ZM', validLengths: [9] },
  { countryCode: '+260', iso: 'ZM', validLengths: [9] },
  { countryCode: '+263', iso: 'ZW', validLengths: [9] },
  { countryCode: '+263', iso: 'ZW', validLengths: [9] },
];

export const findCountryByCode = (codeValue: string | null | undefined): CountryPhoneCode | undefined => {
  if (typeof codeValue !== 'string') {
    return undefined;
  }
  return COUNTRY_PHONE_CODES.find(country => country.countryCode === codeValue);
};
